import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo1_Nuno } from '../../../../../utils/ES/Modals/directors';

const ModalVideoNuno1 = () => {
  return (
    <>
      <ModalVideo
        id="nuno-video-1"
        dataText={TextVideo1_Nuno}
        videoSrc="https://player.vimeo.com/video/800207434?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_NUNO_1"
      />
    </>
  );
};

export default ModalVideoNuno1;
